import Header from 'components/headers/easyPay'
import InitGatewayPayment from 'modules/easyPay/init/indexGatewayPayment'

export default function InitGatewayPaymentPage() {
    return (
        // «پرداخت آسان درگاهی» named an internal route, not the thing the user
        // is doing. This is the confirm step of the payables basket, and the
        // loan repayment's own confirm step is titled the same way.
        <div className="min-h-screen bg-canvas">
            <Header title="تایید و پرداخت" />
            <InitGatewayPayment />
        </div>
    )
}
